export default __webpack_public_path__ + "img/upload-remove.974dc88.svg";